<template>
  <div class="bg-white container">
    <!-- <div class="row">
      <q-checkbox
        class="q-mr-sm"
        color="primary"
        dense
        :value="isSelectAll"
        @input="onChangeSelectAll"
      />
      <div class="title text-black">Select all</div>
    </div> -->
    <!-- <q-separator /> -->
    <div class="row text-black justify-end">
      <div class="col-12 col-md-6">
        <div class="row justify-between items-baseline">
          <div class="text-subtitle2">Sub total</div>
          <div class="text-primary">
            {{ subTotal | formattedPrice }}
          </div>
        </div>
        <div v-if="discountTotal" class="row justify-between items-baseline">
          <div class="text-subtitle2">Total discount</div>
          <div class="text-red">
            {{ discountTotal | formattedPrice | nagativeNumber }}
          </div>
        </div>

        <div
          v-if="promotionalDiscount > 0"
          class="row full-width justify-between q-px-md text-grey-8"
        >
          <div class="text-caption no-bold">Promotional discount</div>
          <div class="text-caption no-bold text-red">
            {{ promotionalDiscount | formattedPrice | nagativeNumber }}
          </div>
        </div>
        <div
          v-if="voucherDiscount > 0"
          class="row full-width justify-between q-px-md text-grey-8"
        >
          <div class="text-caption no-bold">Voucher discount</div>
          <div class="text-caption no-bold text-red">
            {{ voucherDiscount | formattedPrice | nagativeNumber }}
          </div>
        </div>

        <div v-if="deliveryFee" class="row justify-between items-baseline">
          <div class="text-subtitle2">Delivery fee</div>
          <div class="text-black">
            {{ deliveryFee | formattedPrice | positiveNumber }}
          </div>
        </div>
        <div v-if="expressFee" class="row justify-between items-baseline">
          <div class="text-subtitle2">Express fee</div>
          <div class="text-black">
            {{ expressFee | formattedPrice | positiveNumber }}
          </div>
        </div>
        <div class="row justify-between items-baseline">
          <div class="text-h6">Total</div>
          <div class="text-primary text-h6 text-bold">
            {{ grandTotal | formattedPrice }}
          </div>
        </div>
        <q-chip
          dense
          clickable
          v-if="isIncludeOutOfStock"
          class="full-width"
          square
          color="red"
          text-color="white"
          icon="warning"
          label="This order has out of stock items"
          @click="onGoToCart"
        />
        <q-chip
          dense
          clickable
          v-if="isIncludeOverStock"
          class="full-width"
          square
          color="red"
          text-color="white"
          icon="warning"
          label="Some items has quantity more than our stock"
          @click="onGoToCart"
        />
        <q-chip
          dense
          clickable
          v-if="isIncludeUnavailable"
          class="full-width"
          square
          color="red"
          text-color="white"
          icon="warning"
          label="This order has unavailable items"
          @click="onGoToCart"
        />
      </div>
    </div>
    <div class="row">
      <q-btn
        dense
        :loading="loading || placeOrderLoading"
        color="primary"
        @click="onRefresh"
        icon="refresh"
        unelevated
      >
        <template slot="loading">
          <q-spinner-dots color="white" size="1em" />
        </template>
      </q-btn>
      <div style="width: 10px" />
      <q-btn
        dense
        :loading="loading || placeOrderLoading"
        color="primary"
        @click="onSave"
        icon="save"
        unelevated
      >
        <template slot="loading">
          <q-spinner-dots color="white" size="1em" />
        </template>
      </q-btn>
      <div style="width: 10px" />
      <q-btn
        dense
        :loading="loading || placeOrderLoading"
        class="col-grow"
        color="primary"
        label="Checkout"
        @click="onCheckout"
      >
        <template slot="loading">
          <q-spinner-dots color="white" size="1em" />
        </template>
      </q-btn>
    </div>
  </div>
</template>

<script>
import { ShippingType } from "@/entities/order/order";
import { mapGetters, mapState } from "vuex";
import CheckoutCreateOrderSuccess from "@/ui/pages/checkout/CheckoutCreateOrderSuccess";
export default {
  name: "CheckoutFooter",
  components: {
    CheckoutCreateOrderSuccess,
  },
  data() {
    return {
      ShippingType: ShippingType,
    };
  },
  computed: {
    ...mapGetters({
      isSelectAll: "cartData/isSelectAll",
    }),
    ...mapState({
      shippingType: (state) => state["checkout"]["shippingType"],
      subTotal: (state) => state.checkout.subTotal,
      discountTotal: (state) => state.checkout.discountTotal,
      promotionalDiscount: (state) => state.checkout.promotionalDiscount,
      voucherDiscount: (state) => state.checkout.voucherDiscount,
      grandTotal: (state) => state.checkout.grandTotal,
      deliveryFee: (state) => state.checkout.deliveryFee,
      expressFee: (state) => state.checkout.expressFee,
      loading: (state) => state.checkout.costLoading,
      placeOrderLoading: (state) => state.checkout.placeOrderLoading,
      canNationwide: (state) => state["checkout"]["canNationwide"],
      customerPhoneNumber: (state) =>
        state["activeCustomer"].customer.phone_number,
      customerEmail: (state) => state["activeCustomer"].customer.email,
    }),
    ...mapState({
      isIncludeOutOfStock: (state) => state.cartData.outOfStockList.length > 0,
      isIncludeOverStock: (state) => state.cartData.overStockList.length > 0,
      isIncludeUnavailable: (state) =>
        state.cartData.unavailableList.length > 0,
    }),
    ...mapState({
      branchList: (state) => state["checkout"]["branchList"],
    }),
    currentBranch() {
      const branch = this.$store.state["branch"]["branch"];
      if (branch) {
        return parseInt(branch.code);
      }
      return null;
    },
    currentBranchName() {
      const branch = this.$store.state["branch"]["branch"];
      if (branch) {
        return branch.name;
      }
      return null;
    },
    isCurrentBranchCanDeliver() {
      const branchCodeList = this.branchList.map((x) => x.br_code);
      console.log({ branchCodeList });
      if (branchCodeList.indexOf(this.currentBranch) >= 0) {
        return true;
      }
      return false;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: async function (to, from) {
        console.log("to ", to.name);
        await this.$store.dispatch("checkout/getCost");
      },
    },
  },
  methods: {
    // onChangeSelectAll(value) {
    //   this.$store.commit("cartData/setSelectAll", value);
    //   this.$store.dispatch("cartData/getCost");
    // },
    onGoToCart() {
      this.$router.push({
        name: "Cart",
      });
    },
    async onRefresh() {
      console.log("refresh");
      await this.$store.dispatch("checkout/getCost");
      // await this.$store.dispatch("checkout/syncDraftOrder");
    },
    async onSave() {
      const dialog = this.$q.dialog({
        message: "Saving...",
        progress: true, // we enable default settings
        persistent: true, // we want the user to not be able to close it
        ok: false, // we want the user to not be able to close it
      });
      await this.$store.dispatch("checkout/updateDraftOrder");
      setTimeout(() => {
        dialog.hide();
      }, 500);
    },
    async onCheckout() {
      if (this.shippingType == this.ShippingType.DELIVERY) {
        if (this.canNationwide) {
          if (this.currentBranch !== 1000) {
            this.$q
              .dialog({
                title: "Error",
                message: `This order cannot deliver from ${this.currentBranchName}(${this.currentBranch}), Please switch branch to Sukhumvit 33 (1000)`,
              })
              .onOk(() => {
                // console.log('OK')
              })
              .onCancel(() => {
                // console.log('Cancel')
              })
              .onDismiss(() => {
                // console.log('I am triggered on both OK and Cancel')
              });
            return;
          }
        } else if (!this.isCurrentBranchCanDeliver) {
          this.$q
            .dialog({
              title: "Error",
              message: `This order cannot deliver from ${this.currentBranchName}(${this.currentBranch}), Please switch branch`,
            })
            .onOk(() => {
              // console.log('OK')
            })
            .onCancel(() => {
              // console.log('Cancel')
            })
            .onDismiss(() => {
              // console.log('I am triggered on both OK and Cancel')
            });
          return;
        }
      }
      // TODO save comment to shopper
      try {
        await this.$store.dispatch("checkout/validate");
        const rtp = await this.$store.dispatch("checkout/placeOrder");
        console.log({ rtp });

        let phoneNumber = this.customerPhoneNumber;
        if (phoneNumber.startsWith("0")) {
          phoneNumber = phoneNumber.substring(1);
          phoneNumber = "+66" + phoneNumber;
        }

        this.$q
          .dialog({
            // title: "Place order success",
            // message: `Order: ${order.orderId}`,
            cancel: true,
            persistent: true,
            component: CheckoutCreateOrderSuccess,
            // props forwarded to your custom component
            // parent: {
            text: rtp.id,
            orderID: rtp.orderID,
            phoneNumber: phoneNumber,
            email: this.customerEmail,
            grandTotal: this.grandTotal,
            // ...more..props...
            // },
          })
          .onOk(() => {
            // console.log('OK')

            // clear cart
            this.$store.dispatch("cart/clearBasket");
          })
          .onCancel(() => {
            // console.log('Cancel')
          })
          .onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          });
      } catch (error) {
        console.warn(error);
        this.$q
          .dialog({
            title: "Error",
            message: error.message,
          })
          .onOk(() => {
            // console.log('OK')
          })
          .onCancel(() => {
            // console.log('Cancel')
          })
          .onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
          });
      }
    },
  },
};
</script>

<style scoped>
.container {
  padding: 6px 10px !important;
}
</style>
